import React, { FormEvent } from "react";
import Window from "../windows/Window";
import Input from "../ui/Input";
import { Comm } from "../core/comm/Comm";

import "./Emojies.css";
import { EVENTS } from "../core/EVENTS";

export default class Emojies extends React.Component<Emojies.Props, Emojies.State>
{

    emojies = {
        favourites: [
            {title: "face with tears of joy", value: "😂"},
            {title: "smiling face with heart-eyes", value: "😍"},
            {title: "smiling face with smiling eyes", value: "😊"},
            {title: "confused face", value: "😕"},
            {title: "OK hand", value: "👌"},
            {title: "rocket", value: "🚀"},
            {title: "trophy", value: "🏆"},
            {title: "beer mug", value: "🍺"},
            {title: "red heart", value: "❤️"}
        ],
        people: [
            {title: "grinning face with smiling eyes", value: "😄"},
            {title: "grinning face with big eyes", value: "😃"},
            {title: "grinning face", value: "😀"},
            {title: "smiling face with smiling eyes", value: "😊"},
            {title: "winking face", value: "😉"},
            {title: "smiling face with heart-eyes", value: "😍"},
            {title: "face blowing a kiss", value: "😘"},
            {title: "kissing face with closed eyes", value: "😚"},
            {title: "kissing face", value: "😗"},
            {title: "kissing face with smiling eyes", value: "😙"},
            {title: "winking face with tongue", value: "😜"},
            {title: "squinting face with tongue", value: "😝"},
            {title: "face with tongue", value: "😛"},
            {title: "flushed face", value: "😳"},
            {title: "beaming face with smiling eyes", value: "😁"},
            {title: "pensive face", value: "😔"},
            {title: "relieved face", value: "😌"},
            {title: "unamused face", value: "😒"},
            {title: "disappointed face", value: "😞"},
            {title: "persevering face", value: "😣"},
            {title: "crying face", value: "😢"},
            {title: "face with tears of joy", value: "😂"},
            {title: "loudly crying face", value: "😭"},
            {title: "sleepy face", value: "😪"},
            {title: "sad but relieved face", value: "😥"},
            {title: "anxious face with sweat", value: "😰"},
            {title: "grinning face with sweat", value: "😅"},
            {title: "downcast face with sweat", value: "😓"},
            {title: "weary face", value: "😩"},
            {title: "tired face", value: "😫"},
            {title: "fearful face", value: "😨"},
            {title: "face screaming in fear", value: "😱"},
            {title: "angry face", value: "😠"},
            {title: "pouting face", value: "😡"},
            {title: "face with steam from nose", value: "😤"},
            {title: "confounded face", value: "😖"},
            {title: "grinning squinting face", value: "😆"},
            {title: "face savoring food", value: "😋"},
            {title: "face with medical mask", value: "😷"},
            {title: "smiling face with sunglasses", value: "😎"},
            {title: "sleeping face", value: "😴"},
            {title: "dizzy face", value: "😵"},
            {title: "astonished face", value: "😲"},
            {title: "worried face", value: "😟"},
            {title: "frowning face with open mouth", value: "😦"},
            {title: "anguished face", value: "😧"},
            {title: "angry face with horns", value: "👿"},
            {title: "face with open mouth", value: "😮"},
            {title: "grimacing face", value: "😬"},
            {title: "neutral face", value: "😐"},
            {title: "confused face", value: "😕"},
            {title: "hushed face", value: "😯"},
            {title: "smirking face", value: "😏"},
            {title: "expressionless face", value: "😑"},
            {title: "slightly frowning face", value: "🙁"},
            {title: "face with rolling eyes", value: "🙄"},
            {title: "thinking face", value: "🤔"},
            {title: "zipper-mouth face", value: "🤐"},
            {title: "face with thermometer", value: "🤒"},
            {title: "face with head-bandage", value: "🤕"},
            {title: "slightly smiling face", value: "🙂"},
            {title: "upside-down face", value: "🙃"},
            {title: "money-mouth face", value: "🤑"},
            {title: "hugging face", value: "🤗"},
            {title: "nerd face", value: "🤓"},
            {title: "princess", value: "👸"},
            {title: "ogre", value: "👹"},
            {title: "goblin", value: "👺"},
            {title: "see-no-evil monkey", value: "🙈"},
            {title: "hear-no-evil monkey", value: "🙉"},
            {title: "speak-no-evil monkey", value: "🙊"},
            {title: "skull", value: "💀"},
            {title: "alien", value: "👽"},
            {title: "pile of poo", value: "💩"},
            {title: "fire", value: "🔥"},
            {title: "sparkles", value: "✨"},
            {title: "glowing star", value: "🌟"},
            {title: "collision", value: "💥"},
            {title: "sweat droplets", value: "💦"},
            {title: "droplet", value: "💧"},
            {title: "zzz", value: "💤"},
            {title: "dashing away", value: "💨"},
            {title: "ear", value: "👂"},
            {title: "eyes", value: "👀"},
            {title: "nose", value: "👃"},
            {title: "tongue", value: "👅"},
            {title: "mouth", value: "👄"},
            {title: "thumbs up", value: "👍"},
            {title: "thumbs down", value: "👎"},
            {title: "OK hand", value: "👌"},
            {title: "oncoming fist", value: "👊"},
            {title: "raised fist", value: "✊"},
            {title: "waving hand", value: "👋"},
            {title: "raised hand", value: "✋"},
            {title: "open hands", value: "👐"},
            {title: "backhand index pointing up", value: "👆"},
            {title: "backhand index pointing down", value: "👇"},
            {title: "backhand index pointing right", value: "👉"},
            {title: "backhand index pointing left", value: "👈"},
            {title: "sign of the horns", value: "🤘"},
            {title: "hand with fingers splayed", value: "🖐"},
            {title: "vulcan salute", value: "🖖"},
            {title: "middle finger", value: "🖕"},
            {title: "raising hands", value: "🙌"},
            {title: "folded hands", value: "🙏"},
            {title: "clapping hands", value: "👏"},
            {title: "flexed biceps", value: "💪"},
            {title: "woman dancing", value: "💃"},
            {title: "woman and man holding hands", value: "👫"},
            {title: "family", value: "👪"},
            {title: "kiss", value: "💏"},
            {title: "person gesturing OK", value: "🙆"},
            {title: "person gesturing NO", value: "🙅"},
            {title: "person tipping hand", value: "💁"},
            {title: "person raising hand", value: "🙋"},
            {title: "person getting massage", value: "💆"},
            {title: "person getting haircut", value: "💇"},
            {title: "nail polish", value: "💅"},
            {title: "bride with veil", value: "👰"},
            {title: "person pouting", value: "🙎"},
            {title: "person frowning", value: "🙍"},
            {title: "person bowing", value: "🙇"},
            {title: "top hat", value: "🎩"},
            {title: "crown", value: "👑"},
            {title: "red heart", value: "❤️"},
            {title: "yellow heart", value: "💛"},
            {title: "blue heart", value: "💙"},
            {title: "purple heart", value: "💜"},
            {title: "green heart", value: "💚"},
            {title: "broken heart", value: "💔"},
            {title: "growing heart", value: "💗"},
            {title: "beating heart", value: "💓"},
            {title: "two hearts", value: "💕"},
            {title: "sparkling heart", value: "💖"},
            {title: "revolving hearts", value: "💞"},
            {title: "heart with arrow", value: "💘"},
            {title: "love letter", value: "💌"},
            {title: "kiss mark", value: "💋"},
            {title: "ring", value: "💍"},
            {title: "gem stone", value: "💎"},
            {title: "robot", value: "🤖"}
        ],
        nature: [
            {title: "dog face", value: "🐶"},
            {title: "wolf", value: "🐺"},
            {title: "cat face", value: "🐱"},
            {title: "mouse face", value: "🐭"},
            {title: "hamster", value: "🐹"},
            {title: "rabbit face", value: "🐰"},
            {title: "frog", value: "🐸"},
            {title: "tiger face", value: "🐯"},
            {title: "koala", value: "🐨"},
            {title: "bear", value: "🐻"},
            {title: "pig face", value: "🐷"},
            {title: "pig nose", value: "🐽"},
            {title: "cow face", value: "🐮"},
            {title: "boar", value: "🐗"},
            {title: "monkey face", value: "🐵"},
            {title: "monkey", value: "🐒"},
            {title: "horse face", value: "🐴"},
            {title: "ewe", value: "🐑"},
            {title: "elephant", value: "🐘"},
            {title: "panda", value: "🐼"},
            {title: "penguin", value: "🐧"},
            {title: "bird", value: "🐦"},
            {title: "baby chick", value: "🐤"},
            {title: "front-facing baby chick", value: "🐥"},
            {title: "hatching chick", value: "🐣"},
            {title: "chicken", value: "🐔"},
            {title: "snake", value: "🐍"},
            {title: "turtle", value: "🐢"},
            {title: "bug", value: "🐛"},
            {title: "honeybee", value: "🐝"},
            {title: "ant", value: "🐜"},
            {title: "lady beetle", value: "🐞"},
            {title: "snail", value: "🐌"},
            {title: "lion", value: "🦁"},
            {title: "unicorn", value: "🦄"},
            {title: "spider", value: "🕷"},
            {title: "spider web", value: "🕸"},
            {title: "scorpion", value: "🦂"},
            {title: "crab", value: "🦀"},
            {title: "turkey", value: "🦃"},
            {title: "dove", value: "🕊️"},
            {title: "chipmunk", value: "🐿"},
            {title: "octopus", value: "🐙"},
            {title: "spiral shell", value: "🐚"},
            {title: "tropical fish", value: "🐠"},
            {title: "fish", value: "🐟"},
            {title: "dolphin", value: "🐬"},
            {title: "spouting whale", value: "🐳"},
            {title: "horse", value: "🐎"},
            {title: "dragon face", value: "🐲"},
            {title: "blowfish", value: "🐡"},
            {title: "two-hump camel", value: "🐫"},
            {title: "poodle", value: "🐩"},
            {title: "bouquet", value: "💐"},
            {title: "rose", value: "🌹"},
            {title: "sunflower", value: "🌻"},
            {title: "mushroom", value: "🍄"},
            {title: "cactus", value: "🌵"},
            {title: "new moon", value: "🌑"},
            {title: "first quarter moon", value: "🌓"},
            {title: "waxing gibbous moon", value: "🌔"},
            {title: "full moon", value: "🌕"},
            {title: "first quarter moon face", value: "🌛"},
            {title: "crescent moon", value: "🌙"},
            {title: "globe showing Asia-Australia", value: "🌏"},
            {title: "sun behind cloud", value: "⛅"},
            {title: "snowman without snow", value: "⛄"},
            {title: "water wave", value: "🌊"},
            {title: "sun behind small cloud", value: "🌤"},
            {title: "sun behind large cloud", value: "🌥"},
            {title: "sun behind rain cloud", value: "🌦"},
            {title: "cloud with rain", value: "🌧"},
            {title: "cloud with lightning", value: "🌩"},
            {title: "cloud with snow", value: "🌨"},
            {title: "wind face", value: "🌬"},
            {title: "tornado", value: "🌪"}
        ],
        objects: [
            {title: "graduation cap", value: "🎓"},
            {title: "fireworks", value: "🎆"},
            {title: "sparkler", value: "🎇"},
            {title: "jack-o-lantern", value: "🎃"},
            {title: "ghost", value: "👻"},
            {title: "Santa Claus", value: "🎅"},
            {title: "Christmas tree", value: "🎄"},
            {title: "wrapped gift", value: "🎁"},
            {title: "party popper", value: "🎉"},
            {title: "confetti ball", value: "🎊"},
            {title: "balloon", value: "🎈"},
            {title: "light bulb", value: "💡"},
            {title: "toilet", value: "🚽"},
            {title: "wrench", value: "🔧"},
            {title: "nut and bolt", value: "🔩"},
            {title: "hammer", value: "🔨"},
            {title: "cigarette", value: "🚬"},
            {title: "bomb", value: "💣"},
            {title: "pistol", value: "🔫"},
            {title: "kitchen knife", value: "🔪"},
            {title: "pill", value: "💊"},
            {title: "syringe", value: "💉"},
            {title: "money bag", value: "💰"},
            {title: "yen banknote", value: "💴"},
            {title: "dollar banknote", value: "💵"},
            {title: "credit card", value: "💳"},
            {title: "money with wings", value: "💸"},
            {title: "clapper board", value: "🎬"},
            {title: "microphone", value: "🎤"},
            {title: "alien monster", value: "👾"},
            {title: "video game", value: "🎮"},
            {title: "joker", value: "🃏"},
            {title: "mahjong red dragon", value: "🀄"},
            {title: "game die", value: "🎲"},
            {title: "direct hit", value: "🎯"},
            {title: "pool 8 ball", value: "🎱"},
            {title: "chequered flag", value: "🏁"},
            {title: "trophy", value: "🏆"},
            {title: "beer mug", value: "🍺"},
            {title: "cocktail glass", value: "🍸"},
            {title: "tropical drink", value: "🍹"},
            {title: "wine glass", value: "🍷"},
            {title: "fork and knife", value: "🍴"},
            {title: "pizza", value: "🍕"},
            {title: "hamburger", value: "🍔"},
            {title: "french fries", value: "🍟"},
            {title: "poultry leg", value: "🍗"},
            {title: "spaghetti", value: "🍝"},
            {title: "bento box", value: "🍱"},
            {title: "steaming bowl", value: "🍜"},
            {title: "cooking", value: "🍳"},
            {title: "bread", value: "🍞"},
            {title: "doughnut", value: "🍩"},
            {title: "soft ice cream", value: "🍦"},
            {title: "birthday cake", value: "🎂"},
            {title: "shortcake", value: "🍰"},
            {title: "cookie", value: "🍪"},
            {title: "chocolate bar", value: "🍫"},
            {title: "lollipop", value: "🍭"},
            {title: "honey pot", value: "🍯"},
            {title: "red apple", value: "🍎"},
            {title: "cherries", value: "🍒"},
            {title: "strawberry", value: "🍓"},
            {title: "peach", value: "🍑"},
            {title: "banana", value: "🍌"},
            {title: "pineapple", value: "🍍"},
            {title: "eggplant", value: "🍆"},
            {title: "tomato", value: "🍅"},
            {title: "ear of corn", value: "🌽"},
            {title: "hot pepper", value: "🌶"},
            {title: "cheese wedge", value: "🧀"},
            {title: "hot dog", value: "🌭"},
            {title: "taco", value: "🌮"},
            {title: "burrito", value: "🌯"},
            {title: "popcorn", value: "🍿"},
            {title: "bottle with popping cork", value: "🍾"},
            {title: "fork and knife with plate", value: "🍽"},
            {title: "ping pong", value: "🏓"},
            {title: "sports medal", value: "🏅"},
            {title: "military medal", value: "🎖"},
            {title: "joystick", value: "🕹"},
            {title: "hammer and wrench", value: "🛠"},
            {title: "dagger", value: "🗡"}
        ],
        places: [
            {title: "speedboat", value: "🚤"},
            {title: "rocket", value: "🚀"},
            {title: "high-speed train", value: "🚄"},
            {title: "bullet train", value: "🚅"},
            {title: "railway car", value: "🚃"},
            {title: "bus", value: "🚌"},
            {title: "automobile", value: "🚗"},
            {title: "taxi", value: "🚕"},
            {title: "delivery truck", value: "🚚"},
            {title: "police car light", value: "🚨"},
            {title: "police car", value: "🚓"},
            {title: "fire engine", value: "🚒"},
            {title: "ambulance", value: "🚑"},
            {title: "bicycle", value: "🚲"},
            {title: "Japanese symbol for beginner", value: "🔰"},
            {title: "fuel pump", value: "⛽"},
            {title: "red paper lantern", value: "🏮"},
            {title: "slot machine", value: "🎰"},
            {title: "racing car", value: "🏎"},
            {title: "motorcycle", value: "🏍"},
            {title: "small airplane", value: "🛩"},
            {title: "airplane departure", value: "🛫"},
            {title: "airplane arrival", value: "🛬"},
            {title: "satellite", value: "🛰"},
            {title: "motor boat", value: "🛥"},
            {title: "passenger ship", value: "🛳"}
        ],
        symbols: [
            {title: "SOS button", value: "🆘"},
            {title: "no one under eighteen", value: "🔞"},
            {title: "no entry", value: "⛔"},
            {title: "check mark button", value: "✅"},
            {title: "VS button", value: "🆚"},
            {title: "chart increasing with yen", value: "💹"},
            {title: "heavy dollar sign", value: "💲"},
            {title: "currency exchange", value: "💱"},
            {title: "cross mark", value: "❌"},
            {title: "exclamation mark", value: "❗"},
            {title: "question mark", value: "❓"},
            {title: "hollow red circle", value: "⭕"},
            {title: "hundred points", value: "💯"},
            {title: "white flag", value: "🏳"},
            {title: "black flag", value: "🏴"}
        ]
    };

    ref: React.RefObject<HTMLInputElement>;

    constructor(props: Emojies.Props)
    {
        super(props);

        this.ref = React.createRef();

        this.state = {
            input: ""
        };
    }


    onInput(event: FormEvent<HTMLInputElement>)
    {
        this.setState({
            input: event.currentTarget.value
        });
    }


    getEmoijes(emoijes: Array<{title: string, value: string}>, filter?: string)
    {
        const arr: Array<JSX.Element> = [];

        emoijes.forEach(data => {
            if (!filter || data.title.includes(filter))
            {
                arr.push(
                    <span
                        title={data.title}
                        className="emoji"
                        onClick={this.props.onSelect.bind(null, data.value)}
                    >
                        {data.value}
                    </span>
                );
            }
        });

        return arr;
    }


    render()
    {
        const lShared = window.lang.shared;
        const lang = window.lang.game["chat-widget"]["chat-input"]["chat-input-tools"]["chat-input-tool-emoji"];
        return (
            <Window
                id="emojies"
                title={lShared.emoji}
                close={this.props.close}
            >
                <div className="input">
                    <Input 
                        placeholder={lang["search emoji"]}
                        onInput={this.onInput.bind(this)}
                    />
                </div>

                {this.renderFilteredEmoji()}
            </Window>
        );
    }


    renderFilteredEmoji()
    {
        const lang = window.lang.game["chat-widget"]["chat-input"]["chat-input-tools"]["chat-input-tool-emoji"];

        if (this.state.input.length > 0)
        {
            return (
                <div className="content scroll-y">
                    <div className="container">
                        {this.getEmoijes(this.emojies.people, this.state.input)}
                        {this.getEmoijes(this.emojies.nature, this.state.input)}
                        {this.getEmoijes(this.emojies.objects, this.state.input)}
                        {this.getEmoijes(this.emojies.places, this.state.input)}
                    </div>
                </div>
            );
        }
        else
        {
            return (
                <div className="content scroll-y">
                    <div className="title font_upper">{lang.favorites}</div>
                    <div className="container">
                        {this.getEmoijes(this.emojies.favourites)}
                    </div>

                    <div className="title font_upper">{lang.people}</div>
                    <div className="container">
                        {this.getEmoijes(this.emojies.people)}
                    </div>

                    <div className="title font_upper">{lang.nature}</div>
                    <div className="container">
                        {this.getEmoijes(this.emojies.nature)}
                    </div>

                    <div className="title font_upper">{lang.objects}</div>
                    <div className="container">
                        {this.getEmoijes(this.emojies.objects)}
                    </div>

                    <div className="title font_upper">{lang.places}</div>
                    <div className="container">
                        {this.getEmoijes(this.emojies.places)}
                    </div>

                    <div className="title font_upper">{lang.symbols}</div>
                    <div className="container">
                        {this.getEmoijes(this.emojies.symbols)}
                    </div>
                </div>
            );
        }
    }


}

export namespace Emojies
{

    export interface Props
    {
        onSelect: (emoji: string) => void;
        close: () => void;
    }

    export interface State
    {
        input: string;
    }

}